import React from "react";

const AboutPage = () => {
  return (
    <section className="subpage-section">
      <div className="container">
        <h1 className="subpage-title">About</h1>
        <p className="subpage-body">
          FeraBio is built by scientists and engineers who understand nanopore
          sequencing workflows from the ground up. More about our team and
          mission coming soon.
        </p>
      </div>
    </section>
  );
};

export default AboutPage;
